import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function UserDetailsModalControl({ id, icon, title, specialIcon = false }) {
  const dispatch = useDispatch();
  const { tab } = useSelector(store => store.modals);
  const active = (tab === id);

  function handleTab() {
    dispatch({ type: 'CHANGE_TAB', tab: id });
    if (id === 'carrier') {
      dispatch({ type: 'SET_CARRIER_PERMISSIONS_PAGE', page: 'carrierTable' });
    }
  }

  return (
    <div className="w-100 text-center">
      <Button
        id={id}
        color="clear"
        className={[
          'no-click-children rounded-pill p-1 border-lg details-control',
          active ? 'border-white active' : '',
        ].join(' ')}
        onClick={() => handleTab()}
      >
        <div
          className={[
            'rounded-pill d-flex bg-white text-body px-3 py-2',
            'd-flex align-items-center justify-content-center',
          ].join(' ')}
        >
          {specialIcon || <FontAwesomeIcon icon={icon} size="lg" className="me-2" />}
          <h6 className="m-0">{title}</h6>
        </div>
      </Button>
    </div>
  );
}

export default UserDetailsModalControl;
